/* eslint-disable react/prop-types */
import Link from 'next/link';
import React from 'react';
import { useSelector } from 'react-redux';
import { Account_text } from '../../../constant/Translation/Account';
import { Following_text } from '../../../constant/Translation/Following';
import { configsSelector } from '../../../store/feature/configsSlice';

const AccountProfile = ({ account_details, follow }) => {
  const { MARKETPLACE_MODULES, listings_configs } =
    useSelector(configsSelector);

  return account_details !== null ? (
    <div className=" w-full  min-h-[100px] bg-white rounded-card   p-[25px] relative shadow-c-sm">
      <div className=" w-5/6 ">
        <h4 className=" mt-[9px] h4 text-primary font-medium ">
          {account_details?.name}
        </h4>
        <p className=" mt-1.5 flex items-center flex-wrap">
          <span className="text-default_gray  ">
            <p className=" text-default_gray description-caption ">
              @{account_details?.user?.first_name}
            </p>
          </span>
        </p>
        <p className=" mt-3 description-paragraph  flex flex-wrap  gap-x-10 gap-y-3">
          {account_details?.location?.city && (
            <Link
              href={{
                pathname: `/l`,
                query: { city: account_details?.location?.city },
              }}
              passHref
            >
              <a
                rel="noreferrer"
                className="flex  items-center gap-1 hover:text-primary"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                {account_details?.location?.city}
              </a>
            </Link>
          )}

          {/* {account_details?.categories[0]?.name && (
                <span>{account_details?.categories[0]?.name}</span>
              )} */}
          {Number(account_details?.total_followers) > 0 && (
            <span>
              {Number(account_details?.total_followers) > 1
                ? Account_text.storedetail.total_followers
                : Account_text.storedetail.total_follower}{' '}
              {account_details?.total_followers}
            </span>
          )}
          {Number(account_details?.total_listings) > 0 && (
            <span>
              {Number(account_details?.total_listings) > 1
                ? Account_text.storedetail.total_products
                : Account_text.storedetail.total_product}{' '}
              {account_details?.total_listings}
            </span>
          )}
        </p>
      </div>

      <div className=" absolute top-0 ltr:right-0 rtl:left-0 mt-6 ltr:mr-6 rtl:ml-6">
        <button
          className={[
            ' min-w-[145px]  ',
            account_details.following
              ? 'btn-primary-fill '
              : 'btn-primary-outline',
          ].join(' ')}
          onClick={() =>
            follow(account_details?.id, account_details?.following)
          }
        >
          {account_details?.following
            ? Account_text.storelist.following
            : Account_text.storelist.follow}
        </button>
      </div>
    </div>
  ) : (
    <div className=" min-h-[300px] border bg-[#3B3269] bg-opacity-[10%] shadow rounded-card   p-4   w-full mx-auto">
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-3/4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded"></div>
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-5/6"></div>
          </div>
        </div>
      </div>
      <div className="animate-pulse flex space-x-4 mt-5">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-3/4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded"></div>
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-5/6"></div>
          </div>
        </div>
      </div>
      <div className="animate-pulse flex space-x-4 mt-5">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-3/4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded"></div>
            <div className="h-4 bg-[#3B3269] bg-opacity-[20%] rounded-card  w-5/6"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountProfile;
